import $ from 'jquery';
import Video from './Video';
import Viewport from './Viewport';

const headerHeight = 80;

function Hero(element) {
  this.element = element;
  this.$element = $(element);
  this.onViewportChange = $.proxy(this.onViewportChange, this);
  this.$content = this.getContent();
  this.video = this.addVideo();
  this.init();
}

Hero.prototype = {
  init() {
    const $contentType = this.$element.find('.pt194.node');
    if ($contentType.length && this.$content && this.$content.length) {
      Viewport.onChange(this.onViewportChange);
      Viewport.update();
    }
    if ($(document.body).is('.front')) {
      this.seeMore = this.addSeeMore();
    }
    this.ready();
  },
  getContent() {
    return this.$element.find('.node-content');
  },
  addVideo() {
    return new Video(this.element);
  },
  onViewportChange() {
    // Offset row to make room for the content of the post.
    this.$content.each((i, element) => {
      const $content = $(element);
      const $row = $content.closest('.views-row');
      const ch = $content.outerHeight();
      const ph = $row.find('.node-inner').outerHeight();
      $row.css('padding-bottom', $content.outerHeight());
      $row.css('min-height', ch + ph);
    });
  },
  addSeeMore() {
    const $button = $('<button class="see-more" role="button">See more</button>');
    $button.on('click', () => {
      const mobile = $(document.body).width() < 1024;
      const offset = $('#content').offset().top - (mobile ? 0 : headerHeight);
      const scrollNode = document.scrollingElement ? document.scrollingElement : document.body;
      $(scrollNode).animate({ scrollTop: offset }, 500);
    });
    this.$element.append($button);
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default Hero;



// WEBPACK FOOTER //
// ./Hero.js